import React from "react";

const HtmlPdfTable = ({ data,batchEditHistory }) => {
  const drawTableRow = (rowObject, isHeader, rowIndex) => {
    // Apply style or classNames depending on the row type
    let style = {};
    let className = "has-text-centered is-vcentered is-size-7";

    if (isHeader) {
      style['borderBottom'] = '1px solid black';
      className += " has-text-weight-bold";
    } else if (rowObject.isSubHeader) {
      className += " has-text-weight-bold has-text-link";
    }
    
    if (rowObject.isFirstSample) {
      style['paddingTop'] = 5;
    }

    const sampleComments = (!isHeader && !rowObject.isSubHeader) ? rowObject.data[rowObject.data.length - 1] : '';

    if (!sampleComments) {
      style['paddingBottom'] = 5;
    }

    // Style for bordered cells
    const borderStyle = {'border': '0.5px solid #dbdbdb', 'minHeight': '100%'};

    // Used for constructing child keys
    const rowKey = `${rowObject.key} - ${rowIndex}`;

    let showResults = true;

    return (
      <>
        <tr key={ rowKey }>
          {
            rowObject.data.slice(0, rowObject.data.length - 1).map((col, colIndex) => {
              /*
              Check if the span needs to be increased for the comment box, which is only applicable
              for subheaders/batch-level rows.

              In addition, add a border to emulate comment boxes if applicable.

              Default column span is 1 and column span is 3 for comment boxes which is under
              coliform, ecoli, and result headers.
              */
              let colSpan = 1;

              if (rowObject.isSubHeader && colIndex === rowObject.data.length - 2) {
                style['height'] = 0;
                colSpan = 3;
              }

              // If colSpan is 3 then we're dealing with a comment box so return a td element with
              // a special div for displaying the border
              if (colSpan === 3) {
                return  <td 
                  key={ `${rowKey} - ${colIndex}` } 
                  style={ style } 
                  colSpan={ colSpan }
                  className={ className }
                ><div style={ borderStyle }>{ col }</div></td>
              }

              if (!rowObject.isSubHeader && !isHeader) {
                // Apply border to labId and results (if applicable) for samples
                if (colIndex === 2 || (colIndex === 7 && showResults)) {
                  return <td 
                    key={ `${rowKey} - ${colIndex}` } 
                    style={ style } 
                    className={ className }
                  >
                    <div style={ borderStyle }>{ col }</div>
                  </td>;
                }
                
                // If sample row then we need to deal with coliform and ecoli columns
                // which uses checkboxes (if applicable)
                if ((colIndex === 5 || colIndex === 6) && col !== "") {
                  // Results are no longer applicable for this sample row since checkboxes are in place
                  showResults = false;

                  return <td 
                    key={ `${rowKey} - ${colIndex}` } 
                    style={ style } 
                    className={ className }
                  >
                    <input 
                      type="checkbox" 
                      checked={ col === "yes" }
                      readOnly
                    />
                  </td>;
                }
              }

              // No special formatting or styles needed for this column value
              return <td 
                key={ `${rowKey} - ${colIndex}` } 
                style={ style } 
                className={ className }
              >{ col }</td>
            })
          }
        </tr>
        { 
          // Display comment on new row since it is not able to fit in the same row
          !isHeader && !rowObject.isSubHeader && sampleComments !== '' &&
            <tr>
              <td style={{ paddingBottom: '5px' }} className={ className } colSpan='8'>
                <div style={ borderStyle }>
                  { rowObject.data[rowObject.data.length - 1] }
                </div>
              </td>
            </tr>
        }
      </>
    )
  }

  return (
    <>
      <table
        style={{
          width: "100%",
          flexDirection: "row",
          justifyContent: "flex-end",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          {drawTableRow(data[0], true, 0)}
        </thead>
        <tbody>
          {data.slice(1).map((row, rowIndex) => drawTableRow(row, false, rowIndex + 1))}
        </tbody>
      </table>
      <br></br>
      <br></br>
      <br></br>
      {batchEditHistory===undefined || batchEditHistory===null || batchEditHistory==="" ? " " : 
      <div>
        <div
        style={{color:"#3e8ed0", fontSize:"25px"}}
        >History</div>
         <div>{batchEditHistory}</div>
      </div>
      }
    </>
  );
};

export default HtmlPdfTable;
